import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../common/icons/Icon';

export default ({ episodes }) => {
  if (!episodes || !episodes.length) {
    return null;
  }

  return (
    <div className="tv--widget">
      <Link className="tv--widget__large" to={`/subscription/tv/${episodes[0].show.id}/${episodes[0].id}?autoplay`}>
        <div className="ttv-logo__wrapper">
          <Icon icon="TvLogo" className="ttv-logo" />
        </div>
        <div
          className="dash--vid-img dash--vid-img__large"
          style={{ backgroundImage: `url(${episodes[0].image.location})` }}
        >
          <Icon icon="PlayCircle" />
        </div>
        <div className="tv-large__desc">
          <h3>{episodes[0].show.name}</h3>
          <p>{episodes[0].name}</p>
        </div>
      </Link>
      {episodes.length > 1 ? (
        <div className="tv--widget__latest--wrapper">
          <h5>Latest Episodes</h5>
          <div className="tv--widget__latest">
            <div className="tv-small__wrapper">
              {episodes.slice(1).map(episode => {
                return (
                  <Link
                    className="tv-small"
                    to={`/subscription/tv/${episode.show.id}/${episode.id}?autoplay`}
                    key={episode.id}
                  >
                    <div
                      className="dash--vid-img dash--vid-img__small"
                      style={{ backgroundImage: `url(${episode.image.location})` }}
                    >
                      <Icon icon="PlayCircle" />
                    </div>
                    <div className="tv-small__desc">
                      <h6>{episode.show.name}</h6>
                      <p>{episode.name}</p>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <div className="tv--widget__latest tv--widget__latest--empty">
          <div className="tv-empty">
            <Icon icon="TvSad" />
            <p>There are no other shows to watch. Stay tuned for more content!</p>
          </div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/subscription/dashboard/TvWidget.js